import React from "react";
import "./ProgressLoader.css"; // Move styles to this CSS file

const ProgressLoader = () => {
  return (
    <div className="progress-loader">
      <div className="progress-bar-container">
        <div className="progress-bar"></div>
      </div>
    </div>
  );
};

export default ProgressLoader;
